module.exports = __webpack_public_path__ + "static/media/20.7f11b3ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/20.png
// module id = 873
// module chunks = 0